import { Tooltip } from '@mui/material';
import { isEmpty } from 'lodash';
import React, { useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import { fieldTypes, notificationType } from '../../constants/globals';
import Alert from '../Reusable/Alert';
import ComboBoxAutocomplete from '../Reusable/ComboBoxAutocomplete';
import CustomCheckBox from '../Reusable/CustomCheckBox';
import FormWrapper from '../Reusable/FormWrapper/FormWrapper.js';
import InputField from '../Reusable/InputField';
import {
  containsMetaDataFilters,
  filterSettingsPayload,
  numberOfBasicFilters,
  types,
} from './utils';

const EditSettingsForm = (props) => {
  const {
      errors,
      translations,
      type,
      reference,
      formType,
      onSubmitHandler,
      settingsPayload,
      onInputChangeHandler,
      onCheckBoxChange,
      onComboBoxChange,
      getComboOrderNumbers,
    } = props,
    { Placeholders, NotificationMessages } = translations || {};

  const filteredSettingsPayload = useMemo(
    () =>
      type
        ? filterSettingsPayload(settingsPayload, reference, formType)
        : settingsPayload,
    [settingsPayload, reference, type, formType]
  );

  const errorsHandler = (index, fieldType) => {
    const basicFiltersCount = numberOfBasicFilters(settingsPayload);
    const hasMetaData = containsMetaDataFilters(filteredSettingsPayload);

    return errors?.find((e) => {
      const adjustedIndex =
        type && hasMetaData ? index + basicFiltersCount : index;
      return e.index === adjustedIndex && e.property === fieldType;
    })?.message;
  };

  return (
    <FormWrapper submitRef={props.submitRef} onSubmit={onSubmitHandler}>
      {isEmpty(filteredSettingsPayload) &&
        reference === formType.META_DATA_FILTERS && (
          <Alert
            severity={notificationType.info}
            message={NotificationMessages.metaDataNotFound}
            className={'w-100 mb-3'}
          />
        )}
      {filteredSettingsPayload?.map((item, index) => {
        const comboOrderNumbers = getComboOrderNumbers(item);

        return (
          <Row key={`${item.field}`} className="responsive-form-row">
            <Col
              md={2}
              className="d-flex justify-content-start align-items-center responsive-form-col"
            >
              <Tooltip
                title={item.description || translations.Tooltip.notAvailable}
              >
                <label className={'text-bold overflow-auto'}>
                  {item.field}:
                </label>
              </Tooltip>
            </Col>
            <Col md={3}>
              <InputField
                id="ruleName"
                name={Placeholders.name}
                placeholder={Placeholders.name}
                onChange={(event) =>
                  onInputChangeHandler(
                    event,
                    fieldTypes.LABEL,
                    item.id,
                    item.field,
                    fieldTypes.STRING,
                    index
                  )
                }
                required
                value={filteredSettingsPayload[index].label || ''}
                error={errorsHandler(index, fieldTypes.LABEL)}
              />
            </Col>
            <Col md={3}>
              {item.type === types.TEXT && (
                <InputField
                  id="ruleLength"
                  name={Placeholders.length}
                  placeholder={Placeholders.length}
                  onChange={(event) =>
                    onInputChangeHandler(
                      event,
                      fieldTypes.MAX_LENGTH,
                      item.id,
                      item.field,
                      fieldTypes.NUMBER,
                      index
                    )
                  }
                  value={item.maxLength || ''}
                  type="number"
                  required
                  error={errorsHandler(index, fieldTypes.MAX_LENGTH)}
                />
              )}
              {reference === formType?.TABLE && (
                <InputField
                  id="ruleWidth"
                  name={Placeholders.width}
                  placeholder={Placeholders.width}
                  onChange={(event) =>
                    onInputChangeHandler(
                      event,
                      fieldTypes.WIDTH,
                      item.id,
                      fieldTypes.NUMBER,
                      index
                    )
                  }
                  required
                  value={filteredSettingsPayload[index].width || ''}
                  type="number"
                  error={errorsHandler(index, fieldTypes.WIDTH)}
                />
              )}
            </Col>
            <Col md={1} className="responsive-form-col">
              <Tooltip
                title={Placeholders?.enabled}
                arrow={true}
                placement="top"
              >
                <div>
                  <CustomCheckBox
                    name="enabled"
                    className="w-100 text-center"
                    onChange={(e) => onCheckBoxChange(e, item.field)}
                    checked={item.enabled}
                    label={Placeholders?.enabled?.split(' ')?.[0]}
                    labelPlacement="top"
                    classNameLabel={`font-size-14`}
                  />
                </div>
              </Tooltip>
            </Col>
            {reference === formType?.TABLE && (
              <Col md={1} className="responsive-form-col">
                <CustomCheckBox
                  name="hide"
                  className="w-100 text-center"
                  onChange={(e) => onCheckBoxChange(e, item.field)}
                  checked={item.hide}
                  label={Placeholders?.hide?.split(' ')?.[0]}
                  labelPlacement="top"
                  disabled={!item.enabled}
                  classNameLabel={`font-size-14`}
                />
              </Col>
            )}
            <Col className="responsive-form-col">
              <ComboBoxAutocomplete
                id="orderNum"
                data={comboOrderNumbers}
                textExtractor={(a) => `${a}`}
                required
                changeValue={(value) =>
                  onComboBoxChange(
                    fieldTypes.ORDER_NUM,
                    item.field,
                    value,
                    index
                  )
                }
                label={Placeholders?.orderNum}
                updateValue={item.orderNum}
                disabled={!item.enabled}
                error={errorsHandler(index, fieldTypes.ORDER_NUM)}
              />
            </Col>
          </Row>
        );
      })}
    </FormWrapper>
  );
};

export default EditSettingsForm;
